<template>
    <div>
        Spa Pool Availability
    </div>


</template>

<script>

    import { store } from '../store/index';


    export default {
        name: 'SpaPoolAvailability',
        props: {
            leg: String,
        },
        computed: {
            session() {
                return store.getters.session
            }
        },
        methods: {
            onSelection(selection) {
                let payload = {
                    leg: this.leg,
                    selection
                };
                store.dispatch("selectSpaPool", payload);
            }
        }
    }
</script>

<style>
</style>